module.exports = __webpack_public_path__ + "img/6a261c1.png";